import { useSelector } from 'hooks/utils';
import { Organization, selectCollaboratorOrganizations } from 'store/data/collaborators';

export function useOrganizationsByCollaborator(userId?: string): Organization[] {
	return useSelector(state => selectCollaboratorOrganizations(state.data.collaborators, userId));
}
